module.exports = __webpack_public_path__ + "img/5.06ec4487.jpg";